export function isNonEmptyStr(str: string | null | undefined): str is string {
  return str !== null && str !== undefined && str.length > 0;
}

export function splitAt(string: string, atIndex: number): string[] {
  return [string.slice(0, atIndex), string.slice(atIndex)];
}
